// Takes a list of recipients and converts them to a list of sendEmailJob payloads/previews.
// Used for compiliing a list of email previews to view before sending them and to be used as payloads for the sendEmailJob.

import { generateHtmlForRecord } from "../../components/tiptap-editor/editorPreview";
import { getPlaceholderFieldsConfig } from "@/components/tiptap-editor/extensions/placeholder";

import useShareholdersByIds from "@/hooks/shares/useShareholdersByIds";
import useLatestShareData from "@/hooks/shares/useLatestShareData";

export default (recipients, editor) => {
  const recipientIds = recipients.map((r) => r.id) ?? [];

  const { data: shareholdersByIdsQuery, isLoading: isLoadingShareholders } =
    useShareholdersByIds(recipientIds);
  const shareholdersByIds = shareholdersByIdsQuery?.data;

  const shareholderById =
    shareholdersByIds?.reduce((acc, s) => ({ [s.id]: s, ...acc }), {}) ?? {};

  const { data: latestShareDataQuery } = useLatestShareData();
  const latestShareData = latestShareDataQuery?.data;
  const shareTypes = latestShareData?.types?.map((t) => t.shareType);

  return {
    isLoading: isLoadingShareholders,
    data: recipients.map((r) => {
      const id = r.id;
      const investor = shareholderById[id];
      const info = investor?.investorInformation;
      const avatarId = investor?.investorId ?? id;
      const nameFull = info?.name;
      const nameFirst = nameFull?.split(" ")?.shift?.();
      const nameLast = nameFull?.split(" ")?.pop?.();
      const emailAddress = r.email;
      const bankInfo = info?.bankInfo;
      const phoneNumber = info?.telephone;
      const address = info?.address;
      const zipCode = info?.zip;
      const city = info?.city;
      const country = info?.country;
      const sharesOwnedTotal = investor?.details?.numOfTotalShares ?? 0;
      const ownershipPercentageTotal =
        typeof investor?.details?.ownershipPercentage === "number"
          ? Number(investor.details.ownershipPercentage)
          : 0;
      const capitalInvestedTotal = investor?.details?.capitalInvested ?? 0;

      const sharesPlaceholders =
        investor?.details?.types?.reduce((acc, shareType) => {
          const type = shareType?.type?.split("$")?.pop?.();

          return {
            ...acc,
            [`sharesOwned_${type}`]: shareType.shares ?? 0,
            [`capitalInvested_${type}`]: shareType.capitalInvestedForType ?? 0,
          };
        }, {}) ?? {};

      const record = {
        nameFull,
        nameFirst,
        nameLast,
        emailAddress,
        phoneNumber,
        address,
        zipCode,
        city,
        country,
        bankInfo,
        sharesOwnedTotal,
        ownershipPercentageTotal,
        capitalInvestedTotal,
        ...sharesPlaceholders,
      };

      const body = generateHtmlForRecord(
        editor,
        record,
        getPlaceholderFieldsConfig({ shareTypes }),
      );

      return {
        id,
        name: nameFull,
        email: emailAddress,
        avatarId,
        avatarType: investor?.investorTypeOfOwner,
        recordType: "investment",
        body,
        record,
      };
    }),
  };
};
